import { LightningDurationType } from "@/geojson/definitions";
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import React from "react";
import { SmartSelector } from "../../SmartSelector";

type LightningParamSelectorProps = {
  onSelect: (parameter: any) => void;
  selectedItemKey: string;
};

export const LightningParamSelector = ({ onSelect, selectedItemKey }: LightningParamSelectorProps) => {
  const { i18n } = useLingui();
  const activeParameters = React.useMemo(
    () => [
      { label: `1 ${t`min`}`, key: LightningDurationType.LIGHTNINGS_1, value: LightningDurationType.LIGHTNINGS_1 },
      { label: `15 ${t`min`}`, key: LightningDurationType.LIGHTNINGS_15, value: LightningDurationType.LIGHTNINGS_15 },
      { label: `30 ${t`min`}`, key: LightningDurationType.LIGHTNINGS_30, value: LightningDurationType.LIGHTNINGS_30 },
      { label: `1 ${t`hour`}`, key: LightningDurationType.LIGHTNINGS_60, value: LightningDurationType.LIGHTNINGS_60 },
      {
        label: `3 ${t`hours`}`,
        key: LightningDurationType.LIGHTNINGS_180,
        value: LightningDurationType.LIGHTNINGS_180,
      },
      {
        label: `6 ${t`hours`}`,
        key: LightningDurationType.LIGHTNINGS_360,
        value: LightningDurationType.LIGHTNINGS_360,
      },
      {
        label: `12 ${t`hours`}`,
        key: LightningDurationType.LIGHTNINGS_720,
        value: LightningDurationType.LIGHTNINGS_720,
      },
    ],
    [i18n.locale],
  );

  return (
    <SmartSelector
      items={activeParameters}
      selectedItemKey={selectedItemKey.includes("_") ? selectedItemKey : LightningDurationType.LIGHTNINGS_60}
      onSelect={onSelect}
    />
  );
};
